import { COUNTRY, Languages } from 'types/common';

export enum OidcApplicationType {
  WEB = 'web',
  NATIVE = 'native',
}

export enum TenantUsageType {
  SMS = 'sms',
  EMAIL = 'email',
}

export enum EmailTemplateType {
  AUTOMATION = 'automation',
  CRM = 'crm',
  MARKETING = 'marketing',
  OTP = 'otp',
  EMAIL_STANDARD = 'emailStandard',
}

export enum AuthIntentType {
  SIGNIN = 'signin',
  SIGNUP = 'signup',
  LINK_ACCOUNT = 'link-account',
}

export enum EmailTemplateLocale {
  ENGLISH = Languages.en,
  NORWEGIAN = Languages.no,
}

export type CheckoutUser = {
  email: string;
  fullName: string;

  phone?: number;
  countryCode?: COUNTRY;
  isCompany?: boolean;
  companyName?: string;
  organizationNo?: string;
  reference?: string; // reference article where the user comes from in checkout page
  onCheckoutCompletedUrl?: string; // url to redirect to after checkout is completed
};

export class CheckoutStatePaymentData {
  constructor() {
    this.userData = {} as CheckoutUser;
  }

  userData: CheckoutUser;
}
